import _ from 'lodash';
import { createContext, useContext, useEffect, useReducer } from 'react';
import { SportsSeasonContext } from '../../../projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { rssHandlers, rssInitialState, rssReducer } from '../reducers/RssReducer';
import { PageAreaContext } from './PageAreaContext';
import { PageContext } from './PageContext';
import { PageDataContext } from './PageDataContext';
import { ParentContext } from './ParentContext';

/** Global Conversations for the Event */
export const RssContext = createContext();

/** Global Conversations for the Event */
const RssProvider = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { mainFunctions, app_alts } = app_state
  const { altFunctions } = app_alts

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)

  const mediaFeeds = _.get(sportsSeasonContext, 'sportsSeason_state.media_info.mediaFeeds')
  const sportsKey = _.get(sportsSeasonContext, 'sportsSeason_state.sportsKey')
  const _sportsYearAbr = _.get(sportsSeasonContext, 'sportsSeason_state._sportsYearAbr')
  const parentDataKeys = _.get(sportsSeasonContext, 'sportsSeason_state.parentDataKeys')

  // pageContext
  const pageContext = useContext(PageContext); // OK
  const { homeSettings_global } = pageContext ?? {}
  const { rssFeeds: rssFeeds_home } = homeSettings_global ?? {}

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}
  const { feeds } = pageItemsShown ?? {}
  const { componentProps } = feeds ?? {}
  const { rssFeeds, rssFeed, titleSearch, contentSearch } = componentProps ?? {}

  // pageDataContext
  const pageDataContext = useContext(PageDataContext); // OK
  const { pageData_state } = pageDataContext ?? {}
  const { currentPageDataCaption } = pageData_state ?? {}

  // const ts = searchByPageCaption && currentPageDataCaption ? currentPageDataCaption.trim() : titleSearch
  // const cs = searchByPageCaption && currentPageDataCaption ? currentPageDataCaption.trim() : contextSearch

  const { pathViews } = paps_state ?? {}

  // local state 
  const initState = rssInitialState({ fn_cls, mainFunctions, altFunctions, parentDataKeys, sportsKey, _sportsYearAbr, mediaFeeds, pathViews })
  const [rss_state, appUserData_dispatch] = useReducer(rssReducer, initState);
  const rss_handlers = rssHandlers(appUserData_dispatch)

  // useEffect(() => {
  //   if (rssFeeds_home && rssFeeds && sportsKey && _sportsYearAbr) {
  //     fn_cls.getFeeds(rssFeeds_home, rssFeeds, titleSearch, contentSearch).then(srt => {
  //       rss_handlers.handleSet_rssFeeds(srt)
  //     })
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [pathViews.events, rssFeeds_home, rssFeeds, rssFeed, sportsKey, _sportsYearAbr] // does not re-rednder unless uivi has changed
  // )

  return <RssContext.Provider value={{ rss_state, rss_handlers }}>
    {props.children}
  </RssContext.Provider>
}

export default RssProvider